
  import { Options, Vue } from 'vue-class-component';
  import HelloWorld from '../../components/HelloWorld.vue';
  import {DataUtil} from '@/util/DataUtil';
  import {agreementConfig} from '@/config/template';

  @Options({
    components: {
      HelloWorld,
    }
  })
  export default class App extends Vue {
    private temp: string = agreementConfig.template_0617;

    private config: TemplateInterface = {
      productName: '韩莓莓的幸福生活',
      companyFullName: '海南亿成网络技术有限公司',
      companyShortName: '海南亿成',
      officialWebsite: 'http://www.hainanyicheng.com/',
    };

    mounted(){
      this.temp = DataUtil.replaceConfig(this.temp, this.config);
    }
  }
